import styled, { css } from 'styled-components'
import Colors from 'constants/colors'
import Threshold from 'constants/threshold'

export const CoverStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-bottom: 60px;

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 115px;
    z-index: 10;
    color: ${Colors.white};

    h1 {
      margin-bottom: 15px;
    }
    .description {
      display: none;
    }
    span {
      cursor: pointer;
      color: ${Colors.orange};
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
    p {
      margin-bottom: 10px;
    }
    .instruction {
      margin-top: 14px;
    }
  }

  .wrapper__faq-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 115px;
    z-index: 10;
    color: ${Colors.white};

    h1 {
      margin-bottom: 15px;
    }
    span {
      color: ${Colors.orange};
    }
  }

  .mobile {
  }
  .desktop {
    display: none;
  }

  @media (min-width: ${Threshold.phone}) {
    .image-container {
      width: 48vw;
      height: 48vw;
      position: absolute;
      top: 8%;
      clip-path: polygon(16% 0, 100% 0, 100% 75%, 81% 100%, 0 91%, 0% 30%);
      background-color: ${Colors.white};
      border: 20px solid ${Colors.white};

      img {
        width: calc(100% - 10px); //for border poligon
        height: calc(100% - 10px);
        object-fit: cover;
        clip-path: polygon(16% 0, 100% 0, 100% 75%, 81% 100%, 0 91%, 0% 30%);
      }
    }
    .mobile {
      display: none;
    }
    .desktop {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .wrapper {
      align-items: flex-start;
      top: 218px;
      left: 190px;
      h1 {
        margin-bottom: 25px;
        text-align: start;
        font-weight: bold;
        font-size: 35px;
        line-height: 50px;
      }
      .description {
        display: block;
        font-size: 20px;
        line-height: 35px;
      }
      p {
        font-size: 20px;
        line-height: 35px;
        margin-bottom: 30px;
      }
      span {
        font-size: 20px;
        line-height: 30px;
      }
      .instruction {
        margin-top: 20px;
      }
    }

    .wrapper__faq-page {
      align-items: flex-start;
      top: 218px;
      left: 190px;

      h1 {
        margin-bottom: 25px;
        text-align: start;
        font-weight: bold;
        font-size: 35px;
        line-height: 50px;
      }
    }
  }
`
